const PageLoader = () => {
  return (
    <div
      className="absolute left-0 top-0 h-dvh w-dvw flex items-center justify-center"
      data-testid="loader"
    >
      <div className="flex space-x-2 justify-center items-center bg-[transparent] h-screen dark:invert">
        <div className="h-6 w-6 bg-[#6301cc] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-6 w-6 bg-[#6301cc] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-6 w-6 bg-[#6301cc] rounded-full animate-bounce"></div>
      </div>
    </div>
  );
};

export default PageLoader;
